(function () {
  'use strict';

  function parseHTML(str) {
    var div = document.createElement('div');
    div.innerHTML = str;
    return div;
  }

  function hasNextPage(scope) {
    var next = scope.querySelector('.pagination a.next');
    if (!next) return false;
    var li = next.closest('li');
    return li ? !li.classList.contains('disabled') : true;
  }

  function UbiquitiGrid(section) {
    this.section = section;
    this.root = section.querySelector('[data-ubiquiti-collection-root]');
    if (!this.root || this.root.dataset.ubiquitiInit === 'true') return;
    this.root.dataset.ubiquitiInit = 'true';

    this.collectionUrl = this.root.dataset.collectionUrl;
    this.sourceSectionId = this.root.dataset.collectionSectionId || 'main';
    this.inStockOnly = this.resolveInStockOnly();
    this.errorText = this.root.dataset.errorText || '';
    this.loadingText = this.root.dataset.loadingText || 'Loading more...';
    if (!this.collectionUrl) return;

    if (this.inStockOnly) {
      this.markInStockOnly();
    }

    this.params = '';
    this.page = 1;
    this.hasNext = false;
    this.requestToken = 0;
    this.resolvedSectionId = '';
    this.defaultCollectionUrl = this.collectionUrl;

    this.section._ubiquitiGridInstance = this;
    this.loadInitial();
  }

  UbiquitiGrid.prototype.resolveInStockOnly = function () {
    if (this.root.dataset.officeSuppliesGrid !== 'true') return false;
    if (this.section.dataset.officeSuppliesGrid !== 'true') return false;
    return !!this.section.closest('.page-template.office-supplies');
  };

  UbiquitiGrid.prototype.markInStockOnly = function () {
    /* office-supplies mode is set in Liquid; nothing to add at runtime */
  };

  UbiquitiGrid.prototype.withInStockParams = function (params) {
    if (!this.inStockOnly || !this.isInStockFilterActive()) return params || '';
    var built = new URLSearchParams(params || '');
    built.delete('filter.v.availability');
    built.append('filter.v.availability', '1');
    return built.toString();
  };

  UbiquitiGrid.prototype.isInStockFilterActive = function () {
    if (!this.inStockOnly) return false;
    if (!this.template) return true;
    var box = this.findInStockCheckbox();
    return !box || box.checked;
  };

  UbiquitiGrid.prototype.findInStockCheckbox = function () {
    if (!this.template) return null;

    var boxes = this.template.querySelectorAll(
      '.filter-group-display__list-item_checkbox[name="filter.v.availability"]'
    );
    var i;
    for (i = 0; i < boxes.length; i++) {
      if (boxes[i].value === '1') return boxes[i];
    }
    for (i = 0; i < boxes.length; i++) {
      if (this.isOutOfStockCheckbox(boxes[i])) continue;
      var label = boxes[i].id
        ? this.template.querySelector('label[for="' + boxes[i].id + '"]')
        : null;
      if (label && /in\s*stock/i.test(label.textContent)) return boxes[i];
    }
    return null;
  };

  UbiquitiGrid.prototype.isOutOfStockCheckbox = function (cb) {
    if (!cb || cb.name !== 'filter.v.availability') return false;
    if (cb.value === '0') return true;
    if (!this.template || !cb.id) return false;
    var label = this.template.querySelector('label[for="' + cb.id + '"]');
    return label ? /out\s*of\s*stock/i.test(label.textContent) : false;
  };

  UbiquitiGrid.prototype.configureAvailabilityFilter = function () {
    if (!this.inStockOnly || !this.template) return;

    var self = this;
    this.template
      .querySelectorAll('.filter-group-display__list-item_checkbox[name="filter.v.availability"]')
      .forEach(function (cb) {
        if (!self.isOutOfStockCheckbox(cb)) return;
        var item = cb.closest('.filter-group_item');
        if (item) item.remove();
      });

    var inStock = this.findInStockCheckbox();
    if (inStock) inStock.checked = true;
  };

  UbiquitiGrid.prototype.rememberSectionId = function (template) {
    if (!template || this.resolvedSectionId) return;
    var id = template.getAttribute('data-section-id');
    if (id) this.resolvedSectionId = id;
  };

  UbiquitiGrid.prototype.wrapTemplate = function (doc) {
    var template = doc.querySelector('.section-collection-template');
    if (!template) return null;
    this.rememberSectionId(template);
    var wrap = document.createElement('div');
    wrap.appendChild(template);
    return wrap;
  };

  UbiquitiGrid.prototype.buildPageUrl = function (params, page) {
    var qs = [];
    params = this.withInStockParams(params);
    if (params) qs.push(params);
    if (page && page > 1) qs.push('page=' + page);
    return qs.length ? this.collectionUrl + '?' + qs.join('&') : this.collectionUrl;
  };

  UbiquitiGrid.prototype.buildSectionUrl = function (params, page) {
    var sectionId = this.resolvedSectionId || this.sourceSectionId;
    var url = this.collectionUrl + '?section_id=' + encodeURIComponent(sectionId);
    params = this.withInStockParams(params);
    if (params) url += '&' + params;
    if (page && page > 1) url += '&page=' + page;
    return url;
  };

  UbiquitiGrid.prototype.fetchDocument = function (url) {
    return fetch(url, {
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      credentials: 'same-origin'
    }).then(function (res) {
      if (!res.ok) throw new Error('Request failed');
      return res.text();
    });
  };

  UbiquitiGrid.prototype.fetchFullPage = function (params, page) {
    var self = this;
    return this.fetchDocument(this.buildPageUrl(params, page))
      .then(parseHTML)
      .then(function (doc) {
        var wrap = self.wrapTemplate(doc);
        if (!wrap) throw new Error('No collection template');
        return wrap;
      });
  };

  UbiquitiGrid.prototype.fetchScope = function (params, page) {
    var self = this;
    return this.fetchDocument(this.buildSectionUrl(params, page))
      .then(parseHTML)
      .then(function (scope) {
        var template = scope.querySelector('.section-collection-template');
        if (template) {
          self.rememberSectionId(template);
          return scope;
        }
        throw new Error('Empty section response');
      })
      .catch(function () {
        return self.fetchFullPage(params, page);
      });
  };

  UbiquitiGrid.prototype.getInitialParamsFromUrl = function () {
    var params = new URLSearchParams(window.location.search);
    var filterParams = new URLSearchParams();

    params.forEach(function (value, key) {
      if (key.indexOf('filter.') === 0 || key === 'sort_by') {
        filterParams.append(key, value);
      }
    });

    return filterParams.toString();
  };

  UbiquitiGrid.prototype.applyUrlParamsToFilters = function () {
    if (!this.template) return;

    var params = new URLSearchParams(window.location.search);
    var self = this;

    params.forEach(function (value, key) {
      if (key.indexOf('filter.') !== 0) return;

      self.template
        .querySelectorAll('.filter-group-display__list-item_checkbox[name="' + key + '"]')
        .forEach(function (cb) {
          if (cb.value === value) {
            cb.checked = true;
            return;
          }
          try {
            if (decodeURIComponent(cb.value) === value) cb.checked = true;
          } catch (e) {
            /* ignore malformed values */
          }
        });
    });
  };

  UbiquitiGrid.prototype.loadInitial = function () {
    var self = this;
    this.fetchScope(this.getInitialParamsFromUrl(), 1)
      .then(function (scope) {
        self.render(scope);
      })
      .catch(function () {
        self.renderError();
      });
  };

  UbiquitiGrid.prototype.renderError = function () {
    this.root.innerHTML =
      '<p class="ubiquiti-product-grid__empty">' + this.errorText + '</p>';
  };

  UbiquitiGrid.prototype.render = function (scope) {
    var template = scope.querySelector('.section-collection-template');
    if (!template) {
      this.renderError();
      return;
    }

    if (this.observer) this.observer.disconnect();

    template.removeAttribute('data-section-type');
    template.removeAttribute('id');

    this.root.innerHTML = '';
    this.root.appendChild(template);
    this.template = template;

    if (this.inStockOnly) {
      this.markInStockOnly();
      this.configureAvailabilityFilter();
    }

    this.applyUrlParamsToFilters();

    this.gridContainer = template.querySelector('#main-collection-product-grid');
    this.gridWrapper = template.querySelector('#collection-product-grid');

    this.injectInfiniteControls();
    this.bindFilters();
    this.bindSort();
    this.bindGridView();
    this.bindMobileDrawer();
    this.bindMaxlist();

    if (window.CollectionFiltersEnhancements) {
      window.CollectionFiltersEnhancements.init(this.template);
    }

    this.params = this.collectParams();
    this.page = 1;
    this.hasNext = hasNextPage(template);
    this.updateInfiniteControls();

  };

  UbiquitiGrid.prototype.injectInfiniteControls = function () {
    if (!this.gridWrapper) return;
    var wrap = document.createElement('div');
    wrap.className = 'ubiquiti-product-grid__more';

    var status = document.createElement('p');
    status.className = 'ubiquiti-product-grid__load-more';
    status.setAttribute('role', 'status');
    status.setAttribute('aria-live', 'polite');
    status.textContent = this.loadingText;
    status.hidden = true;

    var sentinel = document.createElement('div');
    sentinel.className = 'ubiquiti-product-grid__sentinel';
    sentinel.setAttribute('aria-hidden', 'true');

    wrap.appendChild(status);
    wrap.appendChild(sentinel);
    this.gridWrapper.appendChild(wrap);

    this.loadMoreStatus = status;
    this.sentinel = sentinel;

    var self = this;
    if ('IntersectionObserver' in window) {
      this.observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) self.loadNextPage();
        });
      }, { rootMargin: '600px 0px' });
      this.observer.observe(sentinel);
    }
  };

  UbiquitiGrid.prototype.updateInfiniteControls = function () {
    if (this.loadMoreStatus) {
      this.loadMoreStatus.hidden = !this.hasNext;
    }
    if (this.sentinel) {
      this.sentinel.style.display = this.hasNext ? '' : 'none';
    }
  };

  UbiquitiGrid.prototype.loadNextPage = function () {
    if (this.loadingMore || !this.hasNext) return;
    this.loadingMore = true;
    var self = this;
    var nextPage = this.page + 1;

    this.fetchScope(this.params, nextPage)
      .then(function (scope) {
        var newGrid = scope.querySelector('#main-collection-product-grid');
        if (newGrid && self.gridContainer) {
          newGrid.querySelectorAll('product-card').forEach(function (card) {
            self.gridContainer.appendChild(card);
          });
        }
        self.page = nextPage;
        self.hasNext = hasNextPage(scope);
        self.updateInfiniteControls();
      })
      .catch(function () {
        self.hasNext = false;
        self.updateInfiniteControls();
      })
      .then(function () {
        self.loadingMore = false;
      });
  };

  UbiquitiGrid.prototype.collectParams = function () {
    var params = new URLSearchParams();
    var filterPanel = this.template && this.template.querySelector('#main-collection-filters');

    if (filterPanel && window.CollectionFiltersEnhancements) {
      window.CollectionFiltersEnhancements.syncActiveFormToMain(filterPanel);
      var query = window.CollectionFiltersEnhancements.getFilterQuery(filterPanel);
      if (query) {
        new URLSearchParams(query).forEach(function (value, key) {
          params.append(key, value);
        });
      }
    } else if (this.template) {
      var self = this;
      var seen = {};
      this.template
        .querySelectorAll('.group-type-list-wrapper .filter-group-display__list-item_checkbox:checked, #collection-filters-form .filter-group-display__list-item_checkbox:checked')
        .forEach(function (cb) {
          if (!cb.name) return;
          if (self.inStockOnly && cb.name === 'filter.v.availability') return;
          var key = cb.name + '=' + cb.value;
          if (seen[key]) return;
          seen[key] = true;
          params.append(cb.name, cb.value);
        });

      var priceWrap = this.template.querySelector('.group-type-list-wrapper .range-slider, .main-range-slider');
      if (priceWrap) {
        var min = priceWrap.querySelector('.field__input-min');
        var max = priceWrap.querySelector('.field__input-max');
        if (min && min.name && min.value !== '') params.append(min.name, min.value);
        if (max && max.name && max.value !== '') params.append(max.name, max.value);
      }
    }

    if (this.template) {
      var sort = this.template.querySelector('.select-sort-by');
      if (sort && sort.value) params.append('sort_by', sort.value);
    }

    return this.withInStockParams(params.toString());
  };

  UbiquitiGrid.prototype.applyFilters = function () {
    var self = this;
    var filterPanel = this.template && this.template.querySelector('#main-collection-filters');
    if (filterPanel && window.CollectionFiltersEnhancements) {
      window.CollectionFiltersEnhancements.syncActiveFormToMain(filterPanel);
    }
    var params = this.collectParams();
    var token = ++this.requestToken;

    this.section.classList.add('is-loading');

    this.fetchScope(params, 1)
      .then(function (scope) {
        if (token !== self.requestToken) return;
        self.render(scope);
        self.section.classList.remove('is-loading');
      })
      .catch(function () {
        if (token !== self.requestToken) return;
        self.section.classList.remove('is-loading');
      });
  };

  UbiquitiGrid.prototype.bindFilters = function () {
    var self = this;
    this.template
      .querySelectorAll('.filter-group-display__list-item_checkbox')
      .forEach(function (cb) {
        cb.addEventListener('change', function () {
          self.applyFilters();
        });
      });
  };

  UbiquitiGrid.prototype.bindSort = function () {
    var self = this;
    this.template.querySelectorAll('.select-sort-by').forEach(function (select) {
      select.addEventListener('change', function () {
        self.template.querySelectorAll('.select-sort-by').forEach(function (other) {
          other.value = select.value;
        });
        self.applyFilters();
      });
    });
  };

  UbiquitiGrid.prototype.bindGridView = function () {
    var self = this;
    var container = this.template.querySelector('#collection-product-grid-container');
    if (!container) return;

    this.template.querySelectorAll('.grid-list .grid').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var gridClass = btn.getAttribute('data-grid');
        if (!gridClass) return;
        container.className = gridClass;
        self.persistGridView(gridClass);
      });
    });
  };

  UbiquitiGrid.prototype.persistGridView = function (gridClass) {
    if (!window.Shopify || !window.Shopify.routes) return;
    fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/json;'
      },
      body: JSON.stringify({ attributes: { grid_view: gridClass } })
    }).catch(function () {});
  };

  UbiquitiGrid.prototype.bindMobileDrawer = function () {
    var open = this.template.querySelector('.mobile-filter-icon');
    var close = this.template.querySelector('.js-sidebar-close');
    if (open) {
      open.addEventListener('click', function () {
        document.documentElement.classList.add('overflow-hidden');
        document.body.classList.add('active-sidebar');
      });
    }
    if (close) {
      close.addEventListener('click', function () {
        document.documentElement.classList.remove('overflow-hidden');
        document.body.classList.remove('active-sidebar');
      });
    }
  };

  UbiquitiGrid.prototype.bindMaxlist = function () {
    this.template.querySelectorAll('.maxlist-more').forEach(function (el) {
      el.addEventListener('click', function () {
        var box = this.closest('.filter-maxlist');
        this.classList.add('d-none');
        this.closest('.filter-group_inner').classList.add('maxlist-more-active');
        box.querySelector('.maxlist-less').classList.remove('d-none');
      });
    });
    this.template.querySelectorAll('.maxlist-less').forEach(function (el) {
      el.addEventListener('click', function () {
        var box = this.closest('.filter-maxlist');
        this.classList.add('d-none');
        this.closest('.filter-group_inner').classList.remove('maxlist-more-active');
        box.querySelector('.maxlist-more').classList.remove('d-none');
      });
    });
  };

  function init() {
    document.querySelectorAll('.ubiquiti-product-grid').forEach(function (section) {
      new UbiquitiGrid(section);
    });
  }

  function boot() {
    init();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
